import { useEffect, useState } from 'preact/hooks';

export function navigate(path: string): void {
  if (path === window.location.pathname) return;
  window.history.pushState({}, '', path);
  window.scrollTo(0, 0);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function usePath(): string {
  const [path, setPath] = useState(window.location.pathname);
  useEffect(() => {
    const handler = (): void => setPath(window.location.pathname);
    window.addEventListener('popstate', handler);
    const onClick = (e: MouseEvent): void => {
      const t = e.target;
      if (!(t instanceof Element)) return;
      const a = t.closest('a');
      if (!a) return;
      const href = a.getAttribute('href');
      if (!href || href.startsWith('http') || a.target === '_blank' || e.metaKey || e.ctrlKey)
        return;
      e.preventDefault();
      navigate(href);
    };
    document.addEventListener('click', onClick);
    return () => {
      window.removeEventListener('popstate', handler);
      document.removeEventListener('click', onClick);
    };
  }, []);
  return path;
}
